import { db } from './firebase';
import { 
  collection, 
  getDocs, 
  doc, 
  setDoc, 
  query, 
  orderBy 
} from 'firebase/firestore';

// Kullanıcı verilerini düzeltme fonksiyonu
export const migrateUserData = async () => {
  try {
    console.log('Kullanıcı verileri güncelleniyor...');

    // Önce seviye bilgilerini al
    const levelsRef = collection(db, 'levels');
    const levelsSnapshot = await getDocs(query(levelsRef, orderBy('requiredScore')));
    const levels = levelsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // Tüm kullanıcıları al
    const usersRef = collection(db, 'users');
    const usersSnapshot = await getDocs(usersRef);
    const totalUsers = usersSnapshot.size;
    console.log(`${totalUsers} kullanıcı bulundu.`);

    let updatedCount = 0;

    // Her kullanıcı için
    for (const userDoc of usersSnapshot.docs) {
      const userData = userDoc.data();
      const userRef = doc(db, 'users', userDoc.id);

      // Yeni veri yapısı
      const updatedData = {
        ...userData,
        score: userData.score || 0,
        maxCombo: userData.maxCombo || 0,
        correctAnswers: userData.correctAnswers || 0,
        combo: userData.combo || 0,
        updatedAt: new Date()
      };

      // Seviyeyi hesapla
      let currentLevel = 1;
      for (const level of levels) {
        if (updatedData.score >= level.requiredScore) {
          currentLevel = parseInt(level.name.split(' ')[1]);
        } else {
          break;
        }
      }
      updatedData.level = currentLevel;

      // Verileri güncelle
      await setDoc(userRef, updatedData, { merge: true });
      updatedCount++;
      console.log(`${updatedCount}/${totalUsers} kullanıcı güncellendi: ${userData.username}`);
    }

    console.log('Kullanıcı verileri başarıyla güncellendi!');
    console.log(`Toplam ${updatedCount} kullanıcı güncellendi.`);

    return {
      success: true,
      message: `${updatedCount} kullanıcı başarıyla güncellendi.`,
      updatedCount
    };
  } catch (error) {
    console.error('Kullanıcı verilerini güncelleme hatası:', error);
    throw error;
  }
};

// AdminPanel.js'de kullanmak için bir buton ekleyelim
export const runMigrations = async () => {
  try {
    console.log('Veritabanı güncellemeleri başlatılıyor...');
    
    // Kullanıcı verilerini güncelle
    const userMigrationResult = await migrateUserData();
    console.log('Kullanıcı migration sonucu:', userMigrationResult);

    return {
      success: true,
      message: 'Tüm güncellemeler başarıyla tamamlandı.',
      details: {
        userMigration: userMigrationResult
      }
    };
  } catch (error) {
    console.error('Migration hatası:', error);
    throw error;
  }
}; 